import { Injectable } from '@angular/core';
import { NgxUiLoaderConfig, NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  config: NgxUiLoaderConfig;

  constructor(private ngxService: NgxUiLoaderService) {
    this.config = {
      bgsColor: 'var(--primary-clr-hex)',
      bgsOpacity: 1,
      bgsPosition: 'center-center',
      bgsSize: 110,
      bgsType: 'three-strings',
      blur: 5,
      delay: 0,
      fastFadeOut: true,
      fgsColor: 'red',
      fgsPosition: 'center-center',
      fgsSize: 110,
      fgsType: 'ball-spin-clockwise',
      gap: 29,
      logoPosition: 'center-center',
      logoSize: 120,
      logoUrl: '',
      masterLoaderId: 'master',
      overlayBorderRadius: '0',
      overlayColor: 'rgba(40, 40, 40, 0.8)',
      pbColor: 'red',
      pbDirection: 'ltr',
      pbThickness: 3,
      hasProgressBar: false,
      text: '',
      textColor: '#FFFFFF',
      textPosition: 'center-center',
      maxTime: -1,
      minTime: 300,
    };
  }

  showLoader() {
    this.ngxService.start(); // start foreground loading with 'default' id
  }

  hideLoader() {
    this.ngxService.stop(); // stop foreground loading with 'default' id
  }
}
